module.exports = __webpack_public_path__ + "static/media/incident_triangle_amber.510af1af.svg";